import { registerFr } from '../i18n/index.js';

registerFr({
  // mast and rail
  'Campaigns': 'Campagnes',
  'segment personas feed sequences': 'les personas de segment alimentent les séquences',
  'every draft is written from the person’s own record': 'chaque brouillon est écrit à partir du dossier de la personne',
  'you approve each one': 'vous approuvez chacun',
  'of': 'sur',
  'left this hour': 'restants cette heure',
  'Run tick now': 'Lancer le passage',
  'Running…': 'En cours…',
  'New sequence': 'Nouvelle séquence',
  'Personas': 'Personas',
  'segment': 'de segment',
  'held person personas': 'personas de personne retenus',
  'the campaigns service did not answer': 'le service des campagnes n’a pas répondu',
  'Sequences': 'Séquences',
  'running': 'en cours',
  'draft': 'brouillon',
  'active enrolments': 'inscriptions actives',
  'Drafts waiting': 'Brouillons en attente',
  'step': 'étape',
  'held in Review, never sent from here': 'retenus dans la revue, jamais envoyés d’ici',
  'nothing waiting for a decision': 'rien n’attend de décision',
  'Sent · 7d': 'Envoyés · 7 j',
  'approved, waiting in the outbox': 'approuvés, en attente dans la boîte d’envoi',
  'the outbox could not be read': 'la boîte d’envoi n’a pas pu être lue',
  'Reply rate · 12m': 'Taux de réponse · 12 m',
  'too few to say': 'trop peu pour se prononcer',
  'sent': 'envoyés',
  'replied': 'ont répondu',
  'a rate needs {n}': 'un taux exige {n}',

  // sequences zone
  'a step drafts; it never sends': 'une étape rédige ; elle n’envoie jamais',
  '{cap} per hour across every campaign · {used} used': '{cap} par heure toutes campagnes confondues · {used} utilisés',
  'Name': 'Nom',
  'Autumn 2026 · AI governance': 'Automne 2026 · gouvernance de l’IA',
  'Daily cap': 'Plafond quotidien',
  'Step': 'Étape',
  'Wait · days': 'Attente · jours',
  'Subject': 'Objet',
  'end here if no reply': 'terminer ici en l’absence de réponse',
  'Template — {{first_name}}, {{organisation}} and {{role_title}} are filled from the record':
    'Modèle — {{first_name}}, {{organisation}} et {{role_title}} sont remplis depuis le dossier',
  'Add step': 'Ajouter une étape',
  'Create as draft': 'Créer en brouillon',
  'The steps could not be read.': 'Les étapes n’ont pas pu être lues.',
  'Could not create the sequence.': 'La séquence n’a pas pu être créée.',
  'A new sequence is created as a draft and enrols nobody. Starting it makes its steps due; each due step files a draft proposal under the principal journey:SEQ-…, which you hold in Review and send from the Inbox.':
    'Une nouvelle séquence est créée en brouillon et n’inscrit personne. Son démarrage rend ses étapes dues ; chaque étape due dépose une proposition de brouillon sous le principal journey:SEQ-…, que vous retenez dans la revue et envoyez depuis la boîte de réception.',
  'loading…': 'chargement…',
  'No sequence yet': 'Aucune séquence',
  'A sequence is a list of steps with a wait, a subject and a template. It drafts; it never sends.':
    'Une séquence est une liste d’étapes avec une attente, un objet et un modèle. Elle rédige ; elle n’envoie jamais.',
  'Ref': 'Réf',
  'Status': 'Statut',
  'Steps': 'Étapes',
  'Enrolled': 'Inscrits',
  'Cap': 'Plafond',
  '/d': '/j',
  'Start': 'Démarrer',
  'Pause': 'Suspendre',
  'Resume': 'Reprendre',
  'End': 'Terminer',
  'Enrol': 'Inscrire',
  '{ref} is now {status}': '{ref} est maintenant {status}',
  'ended': 'terminée',
  'Could not change the sequence.': 'La séquence n’a pas pu être modifiée.',
  '{ref} created as a draft. Enrol people, then start it.':
    '{ref} créée en brouillon. Inscrivez des personnes, puis démarrez-la.',

  // the selected sequence
  'Sequence': 'Séquence',
  '{status} · step {n} of {total}': '{status} · étape {n} sur {total}',
  'daily cap {cap} · {suppressed} suppressed · replies thread into the Inbox':
    'plafond quotidien {cap} · {suppressed} supprimées · les réponses arrivent dans la boîte de réception',
  'Subject and template': 'Objet et modèle',
  'Drafts': 'Brouillons',
  'Branch': 'Branche',
  'mail': 'courriel',
  'day': 'jour',
  'waiting in Review': 'en attente dans la revue',
  'reply stops it': 'une réponse l’arrête',
  'end': 'fin',
  'reply': 'réponse',
  'no_reply': 'sans réponse',
  'Find people to enrol': 'Chercher des personnes à inscrire',
  'name, organisation…': 'nom, organisation…',
  'Search': 'Chercher',
  'Enrol {n}': 'Inscrire {n}',
  'Nobody matches.': 'Personne ne correspond.',
  'Do-not-contact, an open deal at negotiation or later, a reply already received and a risk signal in the last 14 days each suppress an enrolment with a reason you can read below.':
    'Le non-contact, une affaire ouverte au stade de la négociation ou au-delà, une réponse déjà reçue et un signal de risque des 14 derniers jours suppriment chacun une inscription, avec un motif lisible ci-dessous.',
  '{n} enrolled in {ref}': '{n} inscrit(s) dans {ref}',
  'Could not enrol.': 'L’inscription a échoué.',
  'The enrolments could not be read.': 'Les inscriptions n’ont pas pu être lues.',
  'Nobody is enrolled. Enrol people; a sequence with no enrolment drafts nothing.':
    'Personne n’est inscrit. Inscrivez des personnes ; une séquence sans inscription ne rédige rien.',
  'Person': 'Personne',
  'Next': 'Prochaine',
  'Why it stopped': 'Pourquoi elle s’est arrêtée',
  'Stop': 'Arrêter',
  'suppressed': 'supprimée',
  'stopped': 'arrêtée',
  'completed': 'terminée',
  'paused': 'suspendue',

  // drafts and attribution
  'Drafts to approve': 'Brouillons à approuver',
  'each one names the sequence and the step that asked for it':
    'chacun nomme la séquence et l’étape qui l’a demandé',
  'Review →': 'Revue →',
  'The campaigns service did not answer, so nothing here was counted.':
    'Le service des campagnes n’a pas répondu : rien n’a été compté ici.',
  'No draft is waiting. A running sequence files one per due step, inside working hours, up to its daily cap.':
    'Aucun brouillon n’attend. Une séquence en cours en dépose un par étape due, pendant les heures ouvrables et jusqu’à son plafond quotidien.',
  'Waiting': 'En attente',
  'Where it is decided': 'Où cela se décide',
  'Review the drafts from {ref}': 'Examiner les brouillons de {ref}',
  'holding one writes it to the outbox; sending is a second click in the Inbox':
    'retenir écrit dans la boîte d’envoi ; envoyer est un second clic dans la boîte de réception',
  'Attribution · 12m': 'Attribution · 12 m',
  'a rate is shown only above 20 assignments': 'un taux n’apparaît qu’au-delà de 20 attributions',
  'The experiments could not be read.': 'Les expériences n’ont pas pu être lues.',
  'No experiment is running. An experiment assigns its variants round-robin to the drafts of one sequence and reads the outcome off replies and meetings.':
    'Aucune expérience en cours. Une expérience attribue ses variantes à tour de rôle aux brouillons d’une séquence et lit le résultat dans les réponses et les rendez-vous.',
  'Variable': 'Variable',
  'Variant': 'Variante',
  'n': 'n',
  'Replies': 'Réponses',
  'Meetings': 'Rendez-vous',
  'Reply rate': 'Taux de réponse',
  'hook': 'accroche',
  'length': 'longueur',
  'tone': 'ton',
  'timing': 'moment',
  'Tick: {status}': 'Passage : {status}',
  'The tick could not be run.': 'Le passage n’a pas pu être lancé.',
  'ok': 'ok',
  'failed': 'échec',
  'skipped': 'ignoré',
  'no_handler': 'aucun gestionnaire',
}, 'CampaignsPage');
